<template>
  <div>
    <v-card>
      <v-card-title
        class="card-title d-flex justify-space-between align-center"
        :style="{ ['background-color']: cardColor, color: 'white' }"
      >
        {{ cardTitle }}
        <div class="d-flex">
          <v-tooltip top nudge-top="18">
            <template #activator="{ attrs, on }">
              <v-icon class="mx-2" v-bind="attrs" v-on="on" size="20" dark> mdi-information-outline </v-icon>
            </template>
            <span>{{ cardInfoText }}</span>
          </v-tooltip>
          <v-tooltip top nudge-top="18">
            <template #activator="{ attrs, on }">
              <v-icon @click="closeCard" v-bind="attrs" v-on="on" size="20" dark> mdi-arrow-collapse </v-icon>
            </template>
            <span>Fechar / Ver menos</span>
          </v-tooltip>
        </div>
      </v-card-title>

      <v-card-text
        v-if="isLoading"
        class="d-flex justify-center align-center"
        style="min-height: 470px"
        ref="grid-wrapper"
      >
        <v-progress-circular width="5" :size="80" indeterminate :color="cardColor" />
      </v-card-text>

      <v-card-text v-else style="position: relative" ref="grid-wrapper">
        <div v-if="isPaginationLoading">
          <v-progress-linear indeterminate :color="cardColor" absolute />
        </div>
        <div v-if="totalRecords === 0" class="pt-5 pb-1 d-flex justify-center">
          <span style="color: #a2a2a2">Nenhuma entrega encontrada</span>
        </div>
        <div v-else>
          <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr))">
            <div v-for="(delivery, i) in deliveries" :key="i">
              <delivery-card :delivery="delivery" />
            </div>
          </div>

          <div class="d-flex justify-center pt-2">
            <v-pagination
              v-model="pageNumber"
              :length="totalPages"
              :total-visible="7"
              @input="onPageChange"
            ></v-pagination>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DeliveryCard from '@/components/Management/DeliveryCard.vue';
import { mapActions } from 'vuex';
import { ExpandedManagementCardHandler } from '@/store/modules/expandedManagementCard';
export default {
  components: {
    DeliveryCard
  },

  props: {
    type: {
      default: '',
      type: String
    }
  },

  data: () => ({
    deliveries: [],
    isLoading: false,
    isPaginationLoading: false,
    totalPages: 0,
    pageNumber: 1,
    totalRecords: 0,
    gridWrapper: null
  }),

  computed: {
    cardObjectByType() {
      return (
        ExpandedManagementCardHandler.getExpandedManagementCardObject(this) || {
          title: 'Em dia',
          color: '#0988BC',
          functionName: 'getShipmentsManagementCtesOnTime',
          infoText: 'Entregas que estão no 3° dia'
        }
      );
    },

    isCardExpanded() {
      return ExpandedManagementCardHandler.getIsCardExpanded(this);
    },

    cardTitle() {
      return this.cardObjectByType.title;
    },

    cardColor() {
      return this.cardObjectByType.color;
    },

    cardInfoText() {
      return this.cardObjectByType.infoText;
    },

    pageSizeByGridWidth() {
      const { gridWrapper } = this;
      if (!gridWrapper) {
        return 10;
      } else if (gridWrapper > 1981) {
        return 14;
      } else if (gridWrapper > 1713) {
        return 12;
      } else if (gridWrapper > 1440) {
        return 10;
      } else if (gridWrapper > 1153) {
        return 8;
      } else if (gridWrapper > 852) {
        return 6;
      }
      return 10;
    }
  },

  watch: {
    isCardExpanded: {
      handler(isCardExpanded) {
        if (isCardExpanded) {
          this.pageNumber = 1;
          this.isLoading = true;
          this.setGridWeightForPagination();
          setTimeout(async () => {
            await this.fetchDeliveriesByType();
            this.isLoading = false;
          }, 20);
        }
      }
    }
  },

  methods: {
    ...mapActions('ShipmentStore', [
      'getShipmentsManagementCtesOnTime',
      'getShipmentsManagementCtesCriticalDay',
      'getShipmentsManagementCtesLate',
      'getTranshipmentsManagementCtesOnTime',
      'getTranshipmentsManagementCtesCriticalDay',
      'getTranshipmentsManagementCtesLate'
    ]),

    async fetchDeliveriesByType() {
      try {
        const { functionName: fetchDeliveries } = this.cardObjectByType;

        const { data, totalPages, totalRecords } = await this[fetchDeliveries]({
          pageNumber: this.pageNumber,
          pageSize: this.pageSizeByGridWidth
        });
        console.log(data);
        this.deliveries = data;
        this.totalPages = totalPages;
        this.totalRecords = totalRecords;
      } catch (error) {
        console.error(error);
      }
    },

    async onPageChange() {
      this.isPaginationLoading = true;
      await this.fetchDeliveriesByType(false);
      this.isPaginationLoading = false;
    },

    closeCard() {
      ExpandedManagementCardHandler.setIsCardExpanded(this, false);
    },
    setGridWeightForPagination() {
      setTimeout(() => {
        this.gridWrapper = this.$refs['grid-wrapper'].clientWidth;
      }, 10);
    }
  }
};
</script>

<style></style>
